module.exports = __webpack_public_path__ + "img/social-facebook-messenger.5f432655.svg";